import { PrintTemplate } from "@/hooks/usePrintTemplates";
import { ESCPOS } from "@/lib/qz-tray";

export interface TemplateFormatting {
  title: {
    start: string;
    end: string;
  };
  items: {
    start: string;
    end: string;
  };
  totals: {
    start: string;
    end: string;
  };
  separator: string;
}

/**
 * Generates ESC/POS formatting commands based on template settings
 */
export function getTemplateFormatting(template: PrintTemplate): TemplateFormatting {
  return {
    title: {
      start: getFormatStart(template.title_bold, template.title_size),
      end: getFormatEnd(template.title_bold, template.title_size),
    },
    items: {
      start: getFormatStart(template.items_bold, template.items_size),
      end: getFormatEnd(template.items_bold, template.items_size),
    },
    totals: {
      start: getFormatStart(template.totals_bold, template.totals_size),
      end: getFormatEnd(template.totals_bold, template.totals_size),
    },
    separator: template.separator_char,
  };
}

function getFormatStart(bold: boolean, size: "normal" | "double"): string {
  let commands = "";
  if (bold) {
    commands += ESCPOS.BOLD_ON;
  }
  if (size === "double") {
    commands += ESCPOS.DOUBLE_SIZE_ON;
  }
  return commands;
}

function getFormatEnd(bold: boolean, size: "normal" | "double"): string {
  let commands = "";
  if (size === "double") {
    commands += ESCPOS.DOUBLE_SIZE_OFF;
  }
  if (bold) {
    commands += ESCPOS.BOLD_OFF;
  }
  return commands;
}

/**
 * Applies template formatting to a section of text
 */
export function formatWithTemplate(
  text: string,
  section: "title" | "items" | "totals",
  template: PrintTemplate
): string {
  const formatting = getTemplateFormatting(template);
  const sectionFormat = formatting[section];
  return sectionFormat.start + text + sectionFormat.end;
}

/**
 * Creates a separator line using the template's separator character
 */
export function getTemplateSeparator(template: PrintTemplate, charsPerLine: number): string {
  return template.separator_char.repeat(charsPerLine) + "\n";
}

/**
 * Formats the footer section based on template settings
 */
export function formatTemplateFooter(template: PrintTemplate): string {
  let footer = "";
  footer += ESCPOS.ALIGN_CENTER;
  
  if (template.footer_text) {
    footer += template.footer_text + "\n";
  }
  
  if (template.show_software_footer) {
    footer += "Altus Food\n";
  }
  
  footer += ESCPOS.ALIGN_LEFT;
  return footer;
}
